import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "cookie_consent";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Suppress in PDF render context (Browserless visits with ?pdf=true)
    if (typeof window !== "undefined" && new URLSearchParams(window.location.search).get("pdf") === "true") {
      return;
    }
    try {
      const value = localStorage.getItem(STORAGE_KEY);
      if (value !== "accepted" && value !== "declined") {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const handleChoice = (choice: "accepted" | "declined") => {
    try {
      localStorage.setItem(STORAGE_KEY, choice);
    } catch {
      // ignore storage errors
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-[9999] border-t border-border bg-card/95 backdrop-blur-md shadow-lg"
    >
      <div className="container mx-auto flex flex-col gap-4 px-6 py-4 md:flex-row md:items-center md:justify-between">
        <p className="text-sm text-muted-foreground max-w-2xl">
          ClearSlot uses cookies to improve your experience and measure performance. See our{" "}
          <Link to="/privacy" className="text-foreground underline hover:text-primary">
            Privacy Policy
          </Link>{" "}
          for details.
        </p>
        <div className="flex items-center gap-2 shrink-0">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => handleChoice("declined")}
          >
            Decline
          </Button>
          <Button
            variant="hero"
            size="sm"
            onClick={() => handleChoice("accepted")}
          >
            Accept cookies
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
